/**
 * Read trusted Recording recommendation profiles for Favorites membership.
 * Writes remain Admin-only; this module only performs individual gets.
 */

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { describeError } from '../utils/errorLog';

export const RECOMMENDATION_PROFILES_COLLECTION = 'recordingRecommendationProfiles';

export function recommendationProfileRef(recordingId) {
  return doc(db, RECOMMENDATION_PROFILES_COLLECTION, recordingId);
}

export async function fetchRecommendationProfiles(recordingIds = []) {
  const unique = [...new Set(
    (Array.isArray(recordingIds) ? recordingIds : [])
      .filter((id) => typeof id === 'string' && id.startsWith('rhy_rec_')),
  )];
  const profilesByRecordingId = {};
  await Promise.all(unique.map(async (recordingId) => {
    try {
      const snap = await getDoc(recommendationProfileRef(recordingId));
      if (!snap.exists()) return;
      profilesByRecordingId[recordingId] = { recordingId, ...snap.data() };
    } catch (error) {
      console.error('fetchRecommendationProfiles failed:', describeError(error));
    }
  }));
  return profilesByRecordingId;
}
